export const GET_EDUCATION = 'GET_EDUCATION';
export const LOADING_EDUCATION = 'LOADING_EDUCATION';
export const SAVE_LOADER_EDUCATION = 'SAVE_LOADER_EDUCATION'